import styled from 'styled-components'

export const ErrorText = styled.div`
  color: #e11900;
  margin-top: 8px;
  line-height: 16px;
`
export const CheckedIcon = styled.div`
  height: 16px;
  width: 16px;
  display: grid;
  place-items: center;
  border-radius: 2px;
  background: ${(p) => {
    return p.disabled ? 'rgba(32, 32, 32, 0.5)' : '#0AA1F4'
  }};
`

export const CheckBoxWrapper = styled.div`
  display: grid;
  place-items: center;
  height: 24px;
  width: 24px;
  user-select: none;
  cursor: pointer;
  margin-right: ${(p) => (p.hasLabel ? '8px' : '0')};
  pointer-events: ${(p) => {
    return p.disabled ? 'none' : ''
  }};
`

export const CheckBoxContainer = styled.div`
  display: flex;
  align-items: center;
  width: ${(p) => (p.hasLabel ? '100%' : 'auto')};
  flex: ${(p) => (p.hasLabel ? '1 1 auto' : '0 0 auto')};
  color: ${(p) => {
    return p.disabled ? 'rgba(32,32,32,0.5)' : ''
  }};
`

export const CheckBoxLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 0;
  flex: 1;
  gap: 8px;

  > span:first-child {
    min-width: 0;
  }
`

export const OptionalText = styled.span`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(32, 32, 32, 0.5);
  margin-left: auto;
  flex-shrink: 0;
`

export { ErrorText as Error }
